import BaseRepository from '@/baseRepository/BaseRepository';
const resource = `/api/v1/wallettransactions`;
const gatwayResource = '/api/v1/gateways';
const onlinePaymentsResource = '/api/v1/onlinepayments';
const paymentsResource = '/api/v1/payments';
export default {
  payByWallet(body, baseURL, headers = {}, params = {}) {
    return BaseRepository.post(`${paymentsResource}/wallet-pay`, body, {
      baseURL,
      headers,
      params,
    });
  },
  getAllWalletTransactions(baseURL, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}`, {
      baseURL,
      headers,
      params,
    });
  },
  getGateways(baseURL, headers = {}, params = {}) {
    return BaseRepository.get(`${gatwayResource}`, {
      baseURL,
      headers,
      params,
    });
  },
  onlinePaymentRequest(body, baseURL, headers = {}, params = {}) {
    return BaseRepository.post(`${onlinePaymentsResource}/request`, body, {
      baseURL,
      headers,
      params,
    });
  },
  getOnlinePaymentById(baseURL, headers = {}, params = {}) {
    return BaseRepository.get(`${onlinePaymentsResource}/by-paymentid`, {
      baseURL,
      headers,
      params,
    });
  },
  getPaymentForRetrayPay(baseURL, headers = {}, params = {}) {
    return BaseRepository.get(`${paymentsResource}/for-retry-pay`, {
      baseURL,
      headers,
      params,
    });
  },
  retryPaymentRequest(body, baseURL, headers = {}, params = {}) {
    return BaseRepository.post(
      `${onlinePaymentsResource}/retry-request`,
      body,
      {
        baseURL,
        headers,
        params,
      }
    );
  },
  cancelPayment(id, baseURL, headers = {}, params = {}) {
    return BaseRepository.post(`${paymentsResource}/${id}/cancel`, null, {
      baseURL,
      headers,
      params,
    });
  },
};
